/* Added by Milos Dronjak (Sep 30, 2025) */

window.addEventListener("load", function() {
  const block = document.querySelector(".additional-info");
  if (!block) return;

  const weightInput = block.querySelector("input[data-passenger-weight-field]");
  const warningMessage = block.querySelector(".additional-info__warning");

  weightInput?.addEventListener("input", function(e) {
    var val = parseInt(e.target.value, 10);

    if (!isNaN(val) && val > 95) {
      if (warningMessage && warningMessage.style.display === "none") {
        $(warningMessage).stop(true, true).slideDown(300);
        weightInput.classList.add("warning");
      }
    } else {
      if (warningMessage && warningMessage.style.display !== "none") {
        $(warningMessage).stop(true, true).slideUp(300);
        weightInput.classList.remove("warning");
      }
    }
  });

  const addToCartForm = document.querySelector("form[id^='AddToCartForm-']");

  /**
   * Attach validation to any button that might bypass the additional form validation
   * @param {HTMLElement} btn - The button element
   */
  function guardButtonAgainstInvalidAdditionalForm(btn) {
    if (!btn) return;

    btn.addEventListener("click", function(e) {
      // If the form is invalid → block checkout and trigger HTML5 messages
      if (!addToCartForm.checkValidity()) {
        e.preventDefault(); // Stops the default browser behavior
        e.stopImmediatePropagation(); // Prevents other event listeners on the same element from running
        addToCartForm.reportValidity(); // Shows browser's validation UI
        // If form is valid, Shopify’s handler will continue as normal
      }
    }, true); // capture phase → runs before Shopify’s own handler
  }

  const buyNowBtn = document.querySelector(
    "shopify-buy-it-now-button button.shopify-payment-button__button"
  );
  guardButtonAgainstInvalidAdditionalForm(buyNowBtn);

  const upsellButton = document.querySelector(
    "button[data-essential-upsell-element='add-to-cart-button']"
  );
  guardButtonAgainstInvalidAdditionalForm(upsellButton);
});